import { FloatingOverlay, FloatingPortal } from '@floating-ui/react';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import React from 'react';

import type { ModalRefType } from '../../Modal';

import { useResponsive } from '../../../hooks/useResponsive';
import { useDropdownContext } from '../DropdownContext';
import { MotionDropdown } from '../../Animate';
import { Scrollbar } from '../../Scrollbar';
import { Modal } from '../../Modal';
import './DropdownMenu.scss';

export interface DropdownMenuProps {
  classes?: {
    content?: string;
    root?: string;
  };
  children: React.ReactNode;
  className?: string;
  /**
   * Title is displayed on mobile devices
   */
  title: string;
  qa?: string;
}

const DropdownMenu = ({
  children,
  className,
  classes,
  qa,
  title,
}: DropdownMenuProps) => {
  const modalRef = React.useRef<ModalRefType>(null);
  const isMobile = useResponsive('down', 'sm');
  const { floatingStyles, getFloatingProps, open, placement, refs, strategy } =
    useDropdownContext();

  const styles = React.useMemo(() => {
    return {
      ...floatingStyles,
      position: strategy,
    };
  }, [floatingStyles, strategy]);

  if (!open) return null;

  if (isMobile) {
    return (
      <Modal initiallyOpen={open} ref={modalRef} title={title} qa={qa} elevated>
        <Modal.Header>
          <Typography className="Mfw-DropdownMenu-title" variant="h3">
            {title}
          </Typography>
        </Modal.Header>
        <div className="Mfw-DropdownMenu-content">{children}</div>
      </Modal>
    );
  }

  /** TODO Return MotionDown and fix content height/width for autocomplete and virtual list */
  return (
    <FloatingOverlay lockScroll>
      <FloatingPortal>
        <Scrollbar
          className={classNames(
            'Mfw-DropdownMenu-root',
            classes?.root,
            className,
          )}
          ref={refs.setFloating}
          style={styles}
          {...getFloatingProps()}
        >
          {placement && (
            // <div className="Mfw-DropdownMenu-menu">{children}</div>
            <MotionDropdown placement={placement}>
              <div
                className={classNames(
                  'Mfw-DropdownMenu-menu',
                  classes?.content,
                )}
              >
                {children}
              </div>
            </MotionDropdown>
          )}
        </Scrollbar>
      </FloatingPortal>
    </FloatingOverlay>
  );
};

export default DropdownMenu;
